import React from "react";
import { styled } from "@mui/material/styles";
import backgroundImg from "../../../images/pulsetrackerCookiesLogo.png";

const Wrapper = styled("div")(() => ({
  // height: "100vh",
  display: "flex",
  backgroundColor: "#ffffff",
  background: `url(${backgroundImg}) no-repeat right bottom fixed`,
  height: "100%",
  backgroundSize: "550px",
  overflow: "hidden",
  fontFamily: "Roboto",
}));

export default function CookiesLayout({ children }) {
  return (
    <>
      <Wrapper>{children}</Wrapper>
    </>
  );
}
